export function getStaleTimeInSeconds(seconds: number) {
    return 1000 * seconds;
}

export function getStaleTimeInMinutes(minutes: number) {
    return getStaleTimeInSeconds(60) * minutes;
}

export function getStaleTimeInHours(hours: number) {
    return getStaleTimeInMinutes(60) * hours;
}
